const jobCardLangs = {
	salary: {
		not_specified: {
			en: "Not provided",
			hu: "Nincs megadva",
			ro: "Nespecificat",
		},
		gross: {
			en: "Gross",
			hu: "Bruttó",
			ro: "Brut",
		},
		netto: {
			en: "Net",
			hu: "Nettó",
			ro: "Net",
		},
		salary: {
			en: "Salary",
			hu: "Fizetés",
			ro: "Salariu",
		},
		salary_range: {
			en: "Salary range",
			hu: "Fizetési sáv",
			ro: "Interval salarial lunar",
		},
		per_month: {
			en: "monthly salary",
			hu: "havi bér",
			ro: "salariu lunar",
		},
		per_hour: {
			en: "hourly rate",
			hu: "órabér",
			ro: "salariu orar",
		},
	},
	card: {
		similar_jobs: {
			en: "Similar jobs",
			hu: "Hasonló állások",
			ro: "Joburi similare",
		},
		undo_save_job: {
			en: "Clear save",
			hu: "Mentés törlése",
			ro: "Șterge jobul",
		},
		save_job: {
			en: "Save job",
			hu: "Állás mentése",
			ro: "Salvează jobul",
		},
		save_company: {
			en: "Add to my Work here! 💗 list",
			hu: "A Dolgoznék itt! 💗 feliratkozással a jövőben értesítünk, ha a cégnél új álláslehetőség nyílik.",
			ro: "Înregistrează-te cu Mi-ar plăcea să lucrez aici 💗 și te vom anunța de îndată ce apare o nouă oportunitate de muncă la compania selectată.",
		},
		remove_company: {
			en: "Remove from Work here! 💗 list",
			hu: "Dolgoznék itt! 💗  leiratkozás",
			ro: "Dezabonare Mi-ar plăcea să lucrez aici 💗.",
		},
		highlighted: {
			en: "featured",
			hu: "kiemelt",
			ro: "evidențiat",
		},
		new_job: {
			en: "new",
			hu: "új",
			ro: "nou",
		},
		szmd_supporter: {
			en: "Lovable Workplaces sponsor",
			hu: "Szerethető Munkahelyek támogató",
			ro: "Sponsori Lovable Workplaces",
		},
		has_gold: {
			en: "gold",
			hu: "gold",
			ro: "gold",
		},
		jobs: {
			en: "job(s)",
			hu: "állás",
			ro: "joburi",
		},
		application_date: {
			en: "Date of application",
			hu: "Jelentkezés időpontja",
			ro: "Data aplicării",
		},
	},
};

const jobProfilePage = {
	howToApply: {
		hu: { en: "Hungarian", hu: "magyar", ro: "maghiară" },
		en: { en: "English", hu: "angol", ro: "engleză" },
		ro: { en: "Romanian", hu: "román", ro: "română" },
		applicationLanguageTitle: {
			en: "Language of application",
			hu: "Jelentkezés nyelve",
			ro: "Limba de aplicare",
		},
	},
	workScheduleBox: {
		flexible: {
			en: "Flexible",
			hu: "Rugalms",
			ro: "Flexibil",
		},
		weeklyWorkingHours: {
			en: "Weekly working hours",
			hu: "Heti munkaidő",
			ro: "Timp de lucru săptămânal",
		},
		hoursPerWeek: {
			en: "hours / week",
			hu: "óra / hét",
			ro: "oră / săptămână",
		},
		coreTime: {
			en: "Core time",
			hu: "Törzsidő",
			ro: "Core time",
		},
	},
	benefitsBox: {
		travel: {
			en: "Travel",
			hu: "Utazás",
			ro: "Călătorii",
		},
		catering: {
			en: "Dining",
			hu: "Étkezés",
			ro: "Mese asigurate",
		},
		training: {
			en: "Training",
			hu: "Képzés",
			ro: "Training",
		},
		assets: {
			en: "Tools",
			hu: "Eszközök",
			ro: "Pachet de beneficii",
		},
		wellbeing: {
			en: "Wellbeing",
			hu: "Jóllét",
			ro: "Wellbeing",
		},
		other: {
			en: "Other",
			hu: "Egyéb",
			ro: "Other",
		},
	},
	educationsBox: {
		noRequiredPaper: {
			en: "No qualification required",
			hu: "Nem kell papír",
			ro: "Nu este necesară calificarea",
		},
		noRequiredLanguage: {
			en: "No language skills required",
			hu: "Nem szükséges nyelvtudás",
			ro: "Nu sunt necesare cunoștințe de limbi străine",
		},
		or: {
			en: "or",
			hu: "vagy",
			ro: "sau",
		},
		and: {
			en: "and",
			hu: "és",
			ro: "și",
		},
	},
};

export default {
	job: jobCardLangs,
	jobProfilePage: jobProfilePage,
};
